import React, { useEffect } from 'react';
import { CheckCircle, Phone, MessageCircle, Shield, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import SEOHead from '../components/SEOHead';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const ThankYouPage = () => {
  const navigate = useNavigate();
  const { language, t } = useLanguage();
  const homeUrl = language === 'en' ? '/en' : '/';

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'GT-NGPQDPHN',
        event_category: 'form',
        event_label: 'contact_form_submission'
      });
      window.gtag('event', 'generate_lead', {
        event_category: 'engagement',
        value: 1
      });
    }
  }, []);
  return (
    <div className="min-h-screen bg-white" data-testid="thank-you-page">
      <SEOHead page="thankYou" />
      <header className="bg-white shadow-sm py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <a href={homeUrl} className="flex-shrink-0" data-testid="logo-link">
            <img 
              src="https://i0.wp.com/bianhi.com/wp-content/uploads/2025/02/logo.png?fit=1698%2C721&ssl=1" 
              alt="Bianhi Medical Hair Restoration" 
              className="h-12 md:h-14 w-auto"
              loading="eager"
            />
          </a>
        </div>
      </header>

      <section className="py-20 md:py-28 bg-gradient-to-br from-[#F0FDFA] via-white to-[#F0FDFA]" data-testid="thank-you-section">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-8">
            <div className="w-24 h-24 mx-auto bg-[#009d9f] rounded-full flex items-center justify-center shadow-lg shadow-[#009d9f]/30 animate-pulse">
              <CheckCircle className="w-14 h-14 text-white" />
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {t('thankYou.title')} <span className="text-[#009d9f]">{t('thankYou.titleHighlight')}</span>!
          </h1>
          
          <p className="text-xl text-slate-600 mb-8 leading-relaxed">{t('thankYou.message')}</p>

          <div className="bg-white rounded-3xl p-8 md:p-10 shadow-xl border border-slate-100 mb-10">
            <p className="text-lg text-slate-700 mb-8 leading-relaxed">{t('thankYou.description')}</p>

            <div className="bg-[#F0FDFA] rounded-2xl p-6 mb-6">
              <div className="flex items-center justify-center gap-2 mb-4">
                <Phone className="w-5 h-5 text-[#009d9f]" />
                <span className="text-slate-700 font-medium">{t('thankYou.immediate')}</span>
              </div>
              <a 
                href="https://wa.me/526645142275" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#128C7E] text-white rounded-full px-8 py-4 text-lg font-semibold shadow-lg transition-all hover:-translate-y-0.5"
                data-testid="whatsapp-button"
              >
                <MessageCircle className="w-6 h-6" />
                WhatsApp: +52 (664) 514 2275
              </a>
            </div>

            <div className="flex items-center justify-center gap-2 text-slate-500">
              <Shield className="w-5 h-5 text-[#009d9f]" />
              <p className="text-sm">{t('thankYou.privacy')}</p>
            </div>
          </div>

          <Button 
            onClick={() => navigate(homeUrl)}
            variant="outline"
            className="border-2 border-[#009d9f] text-[#009d9f] hover:bg-[#009d9f] hover:text-white rounded-full px-8 py-6 text-lg font-semibold transition-all"
            data-testid="back-home-button"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            {t('thankYou.backHome')}
          </Button>
        </div>
      </section>

      <ContactSection />
      <Footer />
    </div>
  );
};

export default ThankYouPage;
